import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled, { css } from 'styled-components';
const Wrapper = styled.div ``;
const Element = styled.div `
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  height: 37px;
  width: auto;
  cursor: pointer;

  > * {
    height: 100%;
  }
`;
const Button = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;

  &:hover {
    background: #f1f1f1;
  }

  &:focus,
  &:active {
    background: inherit;

    &:hover {
      background: #f1f1f1;
    }
  }

  ${({ disabled }) => disabled &&
    css `
      &:hover,
      &:focus,
      &:active {
        background: none;
      }
    `}

  svg {
    width: 14px;
  }
`;
const Input = styled.input `
  ${ButtonReset};
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  font-size: 18px;
  ${fonts.DaxPro['Regular']};
  color: ${brand.grey.grey20};
  text-align: center;
  padding: 0 6px;
  max-width: 44px;
`;
export default {
    Wrapper,
    Element,
    Button,
    Input,
};
